import * as React from "react";
import Button from "components/form/button";
import { format } from "lib/globalize-util";
import Dialog from "components/dialog";

interface IProps {
    open: boolean;
    onRequestClose: () => void;
    onSelect: (mode: "immediate" | "prebook") => void;
}

const styles = {
    actions: {
        display: "flex",
        justifyContent: "space-between",
        textAlign: "center",
    },
    content: {
        maxWidth: "480px",
    },
    button: {
        width: "100%",
        margin: "0 4px 4px",
    },
};

class ModePicker extends React.PureComponent<IProps, any> {
    handleSelect = (mode) => {
        this.props.onSelect(mode);
    };

    render() {
        const { open, onRequestClose } = this.props;

        if (!open) {
            return null;
        }

        return (
            <Dialog
                title={format("Select Order Mode")}
                contentStyle={styles.content}
                open={open}
                onRequestClose={onRequestClose}
                actionsContainerStyle={styles.actions}
                actions={[
                    <Button
                        label={format("Immediate")}
                        style={styles.button}
                        onClick={this.handleSelect.bind(this, "immediate")}
                        data-test="order-mode-immediate"
                        key="immediate"
                    />,
                    <Button
                        label={format("Pre-Book")}
                        style={styles.button}
                        onClick={this.handleSelect.bind(this, "prebook")}
                        data-test="order-mode-prebook"
                        key="prebook"
                    />,
                ]}
            >
                {format("Please choose if your order will be Pre-Book or Immediate.")}
            </Dialog>
        );
    }
}

export default ModePicker;
export const OrderFlowTypePicker = ModePicker;
